import React, { useEffect } from 'react';
import { useWeatherStore } from '../../stores/useUIStore'; // 🟢 1. Importamos el store

const getWeatherIcon = (iconCode) => {
  // Mapea el código del icono de la API a la ruta de nuestra imagen local
  return `/src/assets/wimg/${iconCode.slice(0, 2)}d.png`;
};

const WeatherWidget = () => {
  // 🟢 2. Obtenemos el estado y las acciones del store
  const weatherData = useWeatherStore((state) => state.weatherData);
  const forecastData = useWeatherStore((state) => state.forecastData);
  const isLoading = useWeatherStore((state) => state.isLoading);
  const error = useWeatherStore((state) => state.error);

  // 🟢 3. Cargamos los datos al montar el componente
  useEffect(() => {
    useWeatherStore.getState().fetchWeather();
  }, []);

  if (isLoading && !weatherData) {
    return (
      <div className="bg-gray-800 text-white p-4 rounded-lg shadow-md">
        Cargando clima...
      </div>
    );
  }

  if (error || !weatherData || !forecastData) {
    return (
      <div className="bg-red-800 text-white p-4 rounded-lg shadow-md">
        Error al cargar el clima.
      </div>
    );
  }

  const { name, main, weather } = weatherData;
  const iconUrl = getWeatherIcon(weather[0].icon);

  const getDayName = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('es-ES', { weekday: 'long' });
  };

  return (
    <div className="bg-gray-800 text-white mt-8 p-4 rounded-lg shadow-md">
      {/* Clima de Hoy */}
      <div className="flex items-center justify-between border-b border-gray-700 pb-2">
        <div>
          <h2 className="text-4xl font-bold">{Math.round(main.temp)}°C</h2>
          <p className="capitalize">{weather[0].description}</p>
          <b className="text-sm">{name} - Hoy</b>
        </div>
        <img src={iconUrl} alt={weather[0].description} className="w-16 h-16" />
      </div>

      {/* --- PRONÓSTICO DE LOS PRÓXIMOS DÍAS --- */}
      <div className="mt-4 space-y-2">
        {forecastData.slice(0, 4).map(
          (
            item // Mostramos hasta 4 días
          ) => (
            <div
              key={item.dt}
              className="flex justify-between items-center text-sm"
            >
              <span className="capitalize">{getDayName(item.dt_txt)}</span>
              <div className="flex items-center">
                <img
                  src={getWeatherIcon(item.weather[0].icon)}
                  alt={item.weather[0].description}
                  className="w-6 h-6 mr-2"
                />
                <b>{Math.round(item.main.temp)}°C</b>
              </div>
            </div>
          )
        )}
      </div>
    </div>
  );
};

export default WeatherWidget;
